module.exports = __webpack_public_path__ + "img/56.444a4dba.jpg";